import { Route, Outlet } from 'react-router-dom';
import { ProtectedRoute } from 'ProtectedRoute';
import { hasReportsAccess } from 'Users';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
// The translations register at startup, so they stay in the main bundle with the route.
import './locales/reports/reports-en.json';

export const REPORTS_ROUTES = {
    REPORTS: { path: '/reports' },
};

export function configureReportsRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: REPORTS_ROUTES,
            config: {
                errorHandlingRules: 'reports',
            },
        },
    ];
}

// The page loads as its own chunk, so the Reports code stays out of the main bundle.
async function getLazyReports() {
    const { ReportsComponent } = await import('./components/ReportsComponent');
    return {
        Component: () => (
            <ProtectedRoute accessPolicy="custom" accessPolicyFn={({ currentUser }) => hasReportsAccess(currentUser)}>
                <ReportsComponent />
            </ProtectedRoute>
        ),
    };
}

export function getReportsRoutes() {
    return (
        <Route id="reports-routes" element={<Outlet />}>
            <Route path={REPORTS_ROUTES.REPORTS.path} lazy={getLazyReports} />
        </Route>
    );
}
